import gsap from "gsap";

const $ = require('jquery');

// const animations = {
//     slideDown: {
//         from: obj => obj.transform({translateY: -obj.height()}).opacity(0),
//         to: obj => obj.transform({translateY: 0}).opacity(1)
//     },
//     slideRight: {
//         from: obj => obj.transform({translateX: -obj.width()}).opacity(0),
//         to: obj => obj.transform({translateX: 0}).opacity(1)
//     },
//     slideLeft: {
//         from: obj => obj.transform({translateX: obj.width()}).opacity(0),
//         to: obj => obj.transform({translateX: 0}).opacity(1)
//     },
//     zoomIn: {
//         from: obj => obj.transform({scale:0.1}).opacity(0),
//         to: obj => obj.transform({scale: 1}).opacity(1)
//     }
// }

const animations = {
    slideInDown: {
        translateY: -200,
        opacity: 0,
    },
    slideInRight: {
        translateX: -200,
        opacity: 0
    },
    slideInLeft: {
        translateX: 200,
        opacity: 0
    },
    slideInUp: {
        translateY: 200,
        opacity: 0
    },
    zoomIn: {
        scale: 0,
        opacity: 0,
        transformOrigin: '50% 50%'
    },
    fadeIn: {
        opacity: 0
    },
    robotArm1: {
        rotate: -60,
        transformOrigin: "43 73"
    },
    robotArm2: {
        translateX: -105,
        translateY: -60,
        transformOrigin: "43 73"
    },
    scaleInX: {
        scaleX: 0
    },
    scaleUp: {
        scaleY: 0,
        transformOrigin: "0 100%"
    },
    rotateClockHour: {
        rotate: -359,
        transformOrigin: "20% 85%"
    }
};

var tl = gsap.timeline({
    paused: true
});

let tweens = [];

$("svg *[data-animation]").each((index, el) => {

    let animationSpeed = 1500,
        animationEasing = 'power2',
        animationDelay = 0,
        animationRepeat = false;

    if ($(el).data('speed')) animationSpeed = $(el).data('speed');
    if ($(el).data('delay')) animationDelay = $(el).data('delay');
    if ($(el).data('easing')) animationEasing = $(el).data('easing');
    if ($(el).data('repeat')) animationRepeat = $(el).data('repeat');

    tweens.push(gsap.from(el, {
        ...animations[$(el).data('animation')],
        duration: animationSpeed / 1000,
        delay: (animationDelay / 1000) + 0.5,
        ease: animationEasing,
        paused: true,
        yoyo: true,
        repeat: animationRepeat,
        repeatDelay: .5
    }));

});

let header = document.querySelector('body > header');

$(header).ready(function() {
	
	header.classList.add('is-loaded');
	
	tweens.forEach(tween => tween.play());
	
});
